import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { UserProfile } from "../model/user-profile";
import { ServicePoint } from "../model/servicePoint";


export const ANONYMOUS_USER: UserProfile = {
  userName: '',
  mainGlobalId: '0',
  globalIDList: [],
  selectedGIDs: '',
  accessControl: '',
};

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  public userProfileBS = new BehaviorSubject<UserProfile>(ANONYMOUS_USER);
  private userProfile: UserProfile = ANONYMOUS_USER;

  // user$: Observable<UserProfile> = this.userProfileBS.asObservable().pipe();
  // userProfile: UserProfile = {
  //   userName: undefined,
  //   mainGlobalId: ''
  // };

  constructor() {
    console.log('new UserProfileService');
  }

  getUserProfile(): UserProfile {
    return this.userProfile;
  }

  setUserProfileGlobalId(gid: string): void {
    this.userProfile.mainGlobalId = gid;
  }

  setUserProfileaccessControl(accessControl: string): void {
    this.userProfile.accessControl = accessControl;
  }

  setProfileGlobalIDList(gidList: ServicePoint[]): void {
    this.userProfile.globalIDList = gidList;
  }

  setProfileUserName(userName: string): void {
    this.userProfile.userName = userName;
  }
}
